var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from "react";
import { Col, Row } from "react-bootstrap";
// icons
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import { generatePageHeaderName } from "@frameworks/salesjourney/components/Generic/TransparentHeader/TransparentHeader";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
// components
import AllTab from "./allTab";
import SavedProductMutualFund from "./MutualFund";
import BookmarkApp from "@frameworks/pmsjourney/app/bookmark/BookmarkApp";
// shared-library
import "@frameworks/salesjourney/stylesheets/components/Features/SavedProduct/SavedProduct.scss";
import Common_Shimmer from "@frameworks/shared-library/components/common_shimmer";
import GenericTooltip from "@frameworks/shared-library/components/GenericTooltip";
import GenericTooltipInnerContent from "@frameworks/shared-library/components/GenericTooltipInnerContent";
import useCalculateZoom from "@frameworks/web/utils/useCalculateZoom";
import { ESubProductIds } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import SaveProductOtc from "@frameworks/NCD/pages/SaveProduct";
import { checkIfOtcIsAccessible } from "../../../utils/genericMethods";
var typeMap = {
    261: "mf",
    256: "bonds",
    257: "ncd",
    292: "sp",
    278: "unlistedShares",
    268: "pms",
    293: "aif",
};
var SavedProduct = function (props) {
    var _a;
    var getTypeByCode = function (code) { return typeMap[code]; };
    var _b = __read(React.useState((_a = getTypeByCode(Number(localStorage.getItem("CategoryCode")))) !== null && _a !== void 0 ? _a : "all"), 2), selectedTab = _b[0], setSelectedTab = _b[1];
    var _c = __read(useState({
        mf: 0,
        pms: 0,
        aif: 0,
        sp: 0,
        ncd: 0,
        bonds: 0,
        unlistedShares: 0,
    }), 2), count = _c[0], setCount = _c[1];
    var _d = __read(useState(true), 2), isOtcAccessible = _d[0], setIsOtcAccessible = _d[1];
    var updateCount = function (category, value) {
        setCount(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[category] = value, _a)));
        });
    };
    var renderHeader = function (data, loader, label) {
        return loader ? (React.createElement(Row, null,
            React.createElement(Col, { md: 3 },
                React.createElement(Common_Shimmer, { number: 1 })))) : (React.createElement("label", { className: "DMSansNormal_20_400 " }, "".concat(label, " ").concat(data ? "(".concat(data, ")") : "")));
    };
    var zoom = useCalculateZoom();
    useEffect(function () {
        !!props.setHeaderLeftComponent &&
            props.setHeaderLeftComponent(React.createElement("div", { className: "d-flex align-items-center gap-2" },
                generatePageHeaderName("Saved Products"),
                React.createElement(GenericTooltip, { placement: "bottom", toolTipText: React.createElement(GenericTooltipInnerContent, { tooltipTitle: "View the products you've saved for quick access and easy reference. Save time by adding your favorite items to the list!" }), triggerType: "hover", toolTipClassName: "txn-mf-tooltip-info", noButton: true, button: React.createElement("i", { className: "edel-icon-Information txt_secondary-gray info-block font-20" }), externalClassName: "mt-1" })));
    }, []);
    var content = useMemo(function () {
        switch (selectedTab) {
            case "all":
                return (React.createElement(AllTab, { viewAllClick: function (data) {
                        setSelectedTab(data);
                    }, updateCount: updateCount }));
            case "mf":
                return (React.createElement(SavedProductMutualFund, { viewAll: true, showDataPerPage: 10, header: function (data, loader) {
                        updateCount("mf", data);
                        return renderHeader(data, loader, "Mutual Fund");
                    } }));
            case "pms":
                return (React.createElement(BookmarkApp, { viewAll: false, showDataPerPage: 10, viewAllClickPath: "pms", subCategoryId: Number(ESubProductIds.PMS), isAll: true, setTotalDataRecord: function (value) { return updateCount("pms", value); }, header: function (data, loader) {
                        updateCount("pms", data);
                        renderHeader(data, loader, "PMS");
                    } }));
            case "aif":
                return (React.createElement(BookmarkApp, { viewAll: false, showDataPerPage: 10, subCategoryId: Number(ESubProductIds.AIF), isAll: true, setTotalDataRecord: function (value) { return updateCount("aif", value); }, header: function (data, loader) {
                        updateCount("aif", data);
                        renderHeader(data, loader, "AIF");
                    } }));
            case "sp":
                return (React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.StructuredProducts), isSaveProduct: true, header: function (totalItems) {
                        updateCount("sp", totalItems);
                        return renderHeader(totalItems, false, "Structured Products (SP)");
                    }, allTabPage: false }));
            case "ncd":
                return (React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.NCD), isSaveProduct: true, header: function (totalItems) {
                        updateCount("ncd", totalItems);
                        return renderHeader(totalItems, false, "Non Convertible Debentures (NCD)");
                    }, allTabPage: false }));
            case "bonds":
                return (React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.Bonds), isSaveProduct: true, header: function (totalItems) {
                        updateCount("bonds", totalItems);
                        return renderHeader(totalItems, false, "Bonds");
                    }, allTabPage: false }));
            case "unlistedShares":
                return (React.createElement(SaveProductOtc, { subCategoryId: String(ESubProductIds.UnlistedShares), isSaveProduct: true, header: function (totalItems) {
                        updateCount("unlistedShares", totalItems);
                        return renderHeader(totalItems, false, "Unlisted Shares");
                    }, allTabPage: false }));
            default:
                break;
        }
    }, [selectedTab]);
    var tabArray = useMemo(function () {
        var allCount = Object.values(count).reduce(function (acc, z) { return acc + z; }, 0);
        var baseTabs = [
            {
                title: "All ".concat(allCount > 0 ? "(".concat(allCount, ")") : ""),
                eventKey: "all",
            },
            {
                title: "Mutual Fund ".concat(count.mf > 0 ? "(".concat(count.mf, ")") : "(0)"),
                eventKey: "mf",
            },
            {
                title: "PMS ".concat(count.pms > 0 ? "(".concat(count.pms, ")") : "(0)"),
                eventKey: "pms",
            },
            {
                title: "AIF ".concat(count.aif > 0 ? "(".concat(count.aif, ")") : "(0)"),
                eventKey: "aif",
            },
        ];
        var otcTabs = [
            {
                title: "Structured Products ".concat(count.sp > 0 ? "(".concat(count.sp, ")") : "(0)"),
                eventKey: "sp",
            },
            {
                title: "NCD ".concat(count.ncd > 0 ? "(".concat(count.ncd, ")") : "(0)"),
                eventKey: "ncd",
            },
            {
                title: "Bonds ".concat(count.bonds > 0 ? "(".concat(count.bonds, ")") : "(0)"),
                eventKey: "bonds",
            },
            {
                title: "Unlisted Shares ".concat(count.unlistedShares > 0 ? "(".concat(count.unlistedShares, ")") : "(0)"),
                eventKey: "unlistedShares",
            },
        ];
        return isOtcAccessible ? __spreadArray(__spreadArray([], __read(baseTabs), false), __read(otcTabs), false) : baseTabs;
    }, [count, isOtcAccessible]);
    useEffect(function () {
        checkIfOtcIsAccessible()
            .then(function (value) {
            setIsOtcAccessible(value);
        })
            .catch(function (e) {
            console.error(e);
            setIsOtcAccessible(true);
        });
    }, []);
    return (React.createElement(GridContainer, { parentClass: "mw-100 p-0 primary-saved-product-container" },
        React.createElement("div", { className: "saved-product-tabs", style: { zoom: zoom } },
            React.createElement("div", { className: "d-flex align-items-center gap-4 bg-ghost-white2  tabs-container " },
                React.createElement(GenericTabs, { defaultActiveKey: selectedTab, externalClassName: "generic-full-bordered-tabs w-100", tabsArray: tabArray, callBackFunction: function (data) {
                        setSelectedTab(data);
                    } })),
            content)));
};
export default SavedProduct;
